import { type FC } from 'react';
import { Spinner } from 'react-bootstrap';

import { loader } from './styles';

interface Props {
	isLoading: boolean;
}

const GlobalLoader: FC<Props> = (props) => {
	const { isLoading } = props;

	return (
		isLoading && (
			<div className={loader}>
				<Spinner animation="border" role="status" />
			</div>
		)
	);
};

export default GlobalLoader;
